import { render, staticRenderFns } from "./CobranzasForm.vue?vue&type=template&id=20cc8549&scoped=true"
import script from "./CobranzasForm.vue?vue&type=script&lang=js"
export * from "./CobranzasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc8549",
  null
  
)

export default component.exports